import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// ----- Admin auth helpers -----
const TOKEN_KEY = "prn_admin_token";
const TOKEN_EXP_KEY = "prn_admin_token_exp";

export const getAdminToken = () => {
  const token = sessionStorage.getItem(TOKEN_KEY);
  const exp = sessionStorage.getItem(TOKEN_EXP_KEY);
  if (!token || !exp) return null;
  if (new Date(exp).getTime() < Date.now()) {
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(TOKEN_EXP_KEY);
    return null;
  }
  return token;
};

export const setAdminToken = (token, expiresAt) => {
  sessionStorage.setItem(TOKEN_KEY, token);
  sessionStorage.setItem(TOKEN_EXP_KEY, expiresAt);
};

export const clearAdminToken = () => {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(TOKEN_EXP_KEY);
};

const adminHeaders = () => {
  const t = getAdminToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

// ----- Chat -----
export const startChat = (payload) => api.post("/chat/start", payload).then((r) => r.data);
export const sendMessage = (session_id, message) =>
  api.post("/chat/message", { session_id, message }).then((r) => r.data);
export const nextCase = (session_id) =>
  api.post("/chat/next", { session_id, message: "next" }).then((r) => r.data);
export const switchMode = (session_id, mode) =>
  api.post("/chat/mode", { session_id, mode }).then((r) => r.data);
export const endChat = (session_id) => api.delete(`/chat/${session_id}`);
export const getTranscript = (session_id) =>
  api.get(`/chat/${session_id}/transcript`, { responseType: "text" }).then((r) => r.data);

// ----- Scenarios (public read, admin write) -----
export const listScenarios = (category) =>
  api.get("/scenarios", { params: category ? { category } : {} }).then((r) => r.data);

export const createScenario = (payload) =>
  api.post("/scenarios", payload, { headers: adminHeaders() }).then((r) => r.data);

export const updateScenario = (id, payload) =>
  api.put(`/scenarios/${id}`, payload, { headers: adminHeaders() }).then((r) => r.data);

export const deleteScenario = (id) =>
  api.delete(`/scenarios/${id}`, { headers: adminHeaders() }).then((r) => r.data);

// ----- References (public read, admin write) -----
export const listReferences = (category) =>
  api.get("/references", { params: category ? { category } : {} }).then((r) => r.data);

export const referenceFileUrl = (id) => `${API}/references/${id}/file`;

export const uploadReference = (file, title, category, description) => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("title", title);
  fd.append("category", category);
  fd.append("description", description || "");
  return api
    .post("/references", fd, {
      headers: { ...adminHeaders(), "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};

export const deleteReference = (id) =>
  api.delete(`/references/${id}`, { headers: adminHeaders() }).then((r) => r.data);

export const updateReference = (id, patch) =>
  api.patch(`/references/${id}`, patch, { headers: adminHeaders() }).then((r) => r.data);

export const reorderReferences = (items) =>
  api.post(`/references/reorder`, { items }, { headers: adminHeaders() }).then((r) => r.data);

export const sortReferencesAlpha = () =>
  api.post(`/references/sort-alpha`, {}, { headers: adminHeaders() }).then((r) => r.data);

// ----- Admin auth -----
export const adminLogin = (password) =>
  api.post("/admin/login", { password }).then((r) => {
    setAdminToken(r.data.token, r.data.expires_at);
    return r.data;
  });

export const adminMe = () =>
  api.get("/admin/me", { headers: adminHeaders() }).then((r) => r.data);

export const adminChangePassword = (current_password, new_password) =>
  api
    .post(
      "/admin/change-password",
      { current_password, new_password },
      { headers: adminHeaders() }
    )
    .then((r) => r.data);
